module.exports = __webpack_public_path__ + "static/media/access.1cf9faf1.svg";